<template>
	<div id="login" class="contentLogin">
		<div :class="[isMobile ? 'modLogin mobile' : 'modLogin']">
			<div class="p-3 mb-5 mt-4 bg-white rounded-2 box-shadow fw-500">

				<div class="logo-login">
					<img src="~@/assets/img/logo-fundo-transparente.svg">
					<h1 class="ml-3 mr-3">{{title}}</h1>
				</div>

				<form id="form_login" name="form_login" v-on:submit.prevent="onSubmit">
					<InputUsername @update:updateUsername="updateUsername"/>
					<InputPassword :label="$t('login_password')" :placeholder="$t('login_password_ph')" @update:updatePassword="updatePassword"/>

					<div class="row mb-2" v-if="!isFirstAccess">
						<div class="col-2"></div>
						<div class="col-8 text-center">
							<span class="pointer forgotYourPasswordText" @click="forgotPassword()">{{$t('login_forgot_your_password')}}</span>
						</div>
						<div class="col-2"></div>
					</div>

					<div class="form-group" v-if="!hasHashlogin() && !isFirstAccess">
						<InputOtp :numInputs="6" :label="$t('login_gtoken_ph')" :fromAuthentication=false @update:updateToken="updateToken"/>

						<div class="row mb-4">
							<div class="col-2"></div>
							<div class="col-8 text-center">
								<b-form-checkbox
									id="saveTokenThisDevice"
									name="saveTokenThisDevice"
									v-model="rememberComputer"
									class="inputSaveTokenThisDevice"
									value="1"
									unchecked-value="0"
								>
									<span :class="computedSaveTokenDeviceLabel">{{$t('login_save_token_on_this_device')}}</span>
								</b-form-checkbox>
							</div>
							<div class="col-2"></div>
						</div>
					</div>

					<div :class="[!isFirstAccess ? 'row mt-4 mb-2' : 'row mt-5 mb-2']">
						<div class="col-2"></div>
						<div class="col-8">
							<input
								id="btn_login"
								type="submit"
								:class="buttonEnabled()"
								:value="[!isFirstAccess ? $t('login_title') : $t('login_first_access')]"
								@click="login()"
								:disabled="disabled"
							>
						</div>
						<div class="col-2"></div>
					</div>
				</form>

				<div class="row mb-2">
					<div class="col-2"></div>
					<div class="col-8">
						<hr />
					</div>
					<div class="col-2"></div>
				</div>

				<div class="row mb-4">
					<div class="col-2"></div>
					<div class="col-8">
						<input
							type="submit"
							class="form-control btnReturnTo"
							:value="[!isFirstAccess ? $t('login_first_access') : $t('login_back_to_login')]"
							@click="changeLoginOrFirstAccess()"
						>
					</div>
					<div class="col-2"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InputUsername from './composables/InputUsername.vue';
import InputPassword from './composables/InputPassword.vue';
import InputOtp from './composables/InputOtp.vue';

import loginControl from '@/mixins/Login/loginControl';
import isMobileControl from '@/mixins/Login/isMobileControl';

export default {
	name: 'Login',

	mixins: [
		loginControl,
		isMobileControl
	],

	components: {
		InputUsername,
		InputPassword,
		InputOtp
	},

	data (){
		return {
			perm: [],
			username: null,
			password: null,
			urlGToken: null,
			needGToken: false,
			typePass: 'password',
			hashlogin: '',
			rememberComputer: "0",
			tokens: null,
			disabled: true,
			isFirstAccess: false,
			title: this.$t('login_title'),
			isSuper: false
		}
	},

	watch: {
		username(){
			this.disabled = this.usernameAndPasswordAreEmpty();
		},
		password(){
			this.disabled = this.usernameAndPasswordAreEmpty();
		},
		tokens() {
			if (this.tokens.length == 6) {
				this.disabled = false;

				this.$nextTick(() => {
					this.focus("btn_login");
				});
			}
		},
		isFirstAccess() {
			// Ao trocar entre página de login ou primeiro acesso, coloca o foco no campo disponível
			if (this.username == null || this.username == '') {
				this.$nextTick(() => {
					this.focus("usernameref");
				});
			} else if (this.password == null || this.password == '') {
				this.$nextTick(() => {
					this.focus("passwordref");
				});
			} else {
 				// Não faz nada, pois o foco fica no inputOtp automaticamente
			}
		}
	},

	computed: {
		computedSaveTokenDeviceLabel() {
			let lang = this.$locale.current();
			return lang == 'en'? 'tokenSaveLabelEN': 'tokenSaveLabelPT';
		}
	},

	mounted() {
		// Inicia com o foco no input username
		this.focus("usernameref");
	},

	created(){
		this.clearCookies();

		if (this.$route.name == "LoginFirst") {
			this.changeLoginOrFirstAccess();
		}

		if (this.$route.name == "LoginSuper") {
			this.isSuper = true;
		}

		if (this.$route.name == "LoginFirstSuper") {
			this.isSuper = true;
			this.changeLoginOrFirstAccess();
		}

		this.setLanguage();
	},
}
</script>

<style lang="scss" scoped>
	::v-deep .forgotYourPasswordText {
		color: #007BFF;
		font-size: 14px;
	}

	::v-deep .inputSaveTokenThisDevice {
		font-size: 13px;
		font-weight: 500;
		padding-left: 1.5rem;
	}

	::v-deep .tokenSaveLabelPT {
		margin-left: -4.5rem;
	}

	::v-deep .tokenSaveLabelEN {
		margin-left: -6rem;
	}
</style>
